module.exports = __webpack_public_path__ + "static/media/slack_01.0518359e.jpg";